import {Injectable} from '@angular/core';
import {ITeam} from '../models/team';
import {HttpClient} from '@angular/common/http';
import {AppConstants} from '../utilities/app-constants';
import {API, graphqlOperation} from 'aws-amplify';
import {GraphQLResult} from '@aws-amplify/api/lib/types';
import {IValidationResponse} from '../models/validation-response';
import {FolioHelperService} from '../utilities/folio-helper.service';
import {Mutations, Queries, Subscriptions} from './appsync-services';
import * as moment from 'moment/moment';

@Injectable({
  providedIn: 'root'
})
export class TeamsService {
  localUser: IValidationResponse;
  localUserId;

  constructor(
    private http: HttpClient,
    private folioHelperService: FolioHelperService
  ) { }

  getDataFromLocal() {
    const userAttributes = this.folioHelperService.fetchDataFromLocalStorage('__login_info__');
    if (!userAttributes || userAttributes.length <= 0) {
      alert('User details are not available. Please log in again.');
      return;
    }
    this.localUserId = userAttributes.externalId;

    this.localUser = JSON.parse(
      localStorage.getItem(AppConstants.PARAM_LOCAL_STORAGE_AUTH_LOGIN_INFO)
    );
  }

  // Get Team Details Based on ID
  getTeamByIdQuery(id) {
    this.getDataFromLocal();

    const teamId = new Queries().getTeambyId;
    const teamDetailsById = {
      team_id: id
    };
    return API.graphql(graphqlOperation(teamId, teamDetailsById)) as Promise<GraphQLResult>;
  }

  // Get all Team Details
  getAllTeamsQuery() {
    this.getDataFromLocal();

    const listAllTeams = new Queries().listAllTeams;
    const teamDetails = {
      envId: this.localUser ? this.localUser.customerId : 0,
      status: 1
    };
    const allTeams = API.graphql(graphqlOperation(listAllTeams, teamDetails)) as Promise<GraphQLResult>;
    return allTeams;
  }

  // Create Team
  createTeamQuery(data: ITeam) {
    this.getDataFromLocal();

    const createTeam = new Mutations().createTeam;

    const teamDetails = {
      team_name: data.TEAM_NAME,
      admin: data.TEAM_LEAD,
      envId: this.localUser.customerId,
      createdUserToken: this.localUserId
    };

    const newEvent = API.graphql(
      graphqlOperation(createTeam, teamDetails)
    ) as Promise<GraphQLResult>;

    return newEvent;
  }

  // Create UserToTeamRelation
  assignUserToTeamMutation(teamId, teamObj) {
    this.getDataFromLocal();
    const UserToTeam = new Mutations().assignUsersToTeam;
    const teamMembers = teamObj.teamMembers;
    const teamsArray = [];
    teamMembers.forEach(teamMember => {
      const {EXTERNAL_ID, ACTUAL_END_DATE, ACTUAL_START_DATE, ADVISOR, EXPECTED_END_DATE, EXPECTED_START_DATE} = teamMember;
      // check here
      if (teamMember.EXTERNAL_ID) {
        const team = {
          team_id: teamId,
          user_id: JSON.stringify(EXTERNAL_ID),
          created_by: JSON.stringify(this.localUserId),
          actual_end_date: ACTUAL_END_DATE ? JSON.stringify(moment(ACTUAL_END_DATE).format('yyyy-MM-DD')) : null,
          actual_start_date: ACTUAL_START_DATE ? JSON.stringify(moment(ACTUAL_START_DATE).format('yyyy-MM-DD')) : null,
          advisor: JSON.stringify(ADVISOR),
          expected_end_date: EXPECTED_END_DATE ? JSON.stringify(moment(EXPECTED_END_DATE).format('yyyy-MM-DD')) : null,
          expected_start_date: EXPECTED_START_DATE ? JSON.stringify(moment(EXPECTED_START_DATE).format('yyyy-MM-DD')) : null
        };
        teamsArray.push(team);
      }
    });
    return API.graphql(graphqlOperation(UserToTeam, {data: teamsArray})) as Promise<GraphQLResult>;
  }


  // Update Team
  updateTeamMutation(data) {
    this.getDataFromLocal();

    const updateTeam = new Mutations().updateTeam;
    const teamDetails = {
      team_id: +data.TEAM_ID,
      team_name: data.TEAM_NAME,
      team_lead: data.TEAM_LEAD,
      envId: this.localUser.customerId,
      createdUserToken: this.localUserId

    };
    const newEvent = API.graphql(
      graphqlOperation(updateTeam, teamDetails)
    ) as Promise<GraphQLResult>;

    return newEvent;
  }

  // update User to Team Relation
  updateUserToTeamMutation(teamId, teamObj) {
    this.getDataFromLocal();

    const UserToTeam = new Mutations().updateUserToTeam;
    const teamMembers = teamObj.teamMembers;
    const teamsArray = [];
    teamMembers.forEach(teamMember => {
      const {EXTERNAL_ID, ACTUAL_END_DATE, ACTUAL_START_DATE, ADVISOR, EXPECTED_END_DATE, EXPECTED_START_DATE} = teamMember;
      // check here
      if (teamMember.EXTERNAL_ID) {
        const team = {
          team_id: teamId,
          user_id: JSON.stringify(EXTERNAL_ID),
          created_by: JSON.stringify(this.localUserId),
          actual_end_date: ACTUAL_END_DATE ? JSON.stringify(moment(ACTUAL_END_DATE).format('yyyy-MM-DD')) : null,
          actual_start_date: ACTUAL_START_DATE ? JSON.stringify(moment(ACTUAL_START_DATE).format('yyyy-MM-DD')) : null,
          advisor: JSON.stringify(ADVISOR),
          expected_end_date: EXPECTED_END_DATE ? JSON.stringify(moment(EXPECTED_END_DATE).format('yyyy-MM-DD')) : null,
          expected_start_date: EXPECTED_START_DATE ? JSON.stringify(moment(EXPECTED_START_DATE).format('yyyy-MM-DD')) : null
        };
        teamsArray.push(team);
      }
    });
    return API.graphql(graphqlOperation(UserToTeam, {data: teamsArray})) as Promise<GraphQLResult>;
  }

  // Delete Team
  deleteTeamMutation(teamID) {
    this.getDataFromLocal();

    const deleteTeam = new Mutations().deleteTeam;
    const teamDetails = {
      teamId: teamID
    };
    const newEvent = API.graphql(graphqlOperation(deleteTeam, teamDetails)) as Promise<GraphQLResult>;
    return newEvent;
  }

  onCreateTeamSubscription() {
    this.getDataFromLocal();

    const teamDetails = {
      id: ''
    };
    const onCreateTeamSubscription = new Subscriptions().onCreateTeamSubscription;
    return API.graphql(graphqlOperation(onCreateTeamSubscription));
  }

}
